import React from 'react'
import { Route, Routes } from 'react-router-dom'
import RouteGenerator from 'components/RouteGenerator'
import NovaSenha from 'views/login/NovaSenha'
import Login from 'views/login'
import NotFound from 'views/notFound'
import LandingPage from 'views/landingPage'
import CadastroInicial from 'views/cadastros/Steps/CadastroInicial'
import CreditoConsignado from 'views/produtos/CreditoConsignado'
import Fgts from 'views/produtos/Fgts'
import CartaoConsignado from 'views/produtos/CartaoConsignado'
import Produtos from 'views/produtos'
import CreditoPessoal from 'views/produtos/CreditoPessoal'
import Sobre from 'views/sobre'
import TrabalheConosco from 'views/trabalheConosco'
import SejaParceiro from 'views/sejaParceiro'
import PoliticaPrivacidade from 'views/politicaPrivacidade'
import AvisoPrivacidade from 'views/avisoPrivacidade'
import TermoDeUso from 'views/termoDeUso'

const AppRoutes = () => {
  return (
    <Routes>
      {RouteGenerator()}
      <Route path="/nova-senha/:id" element={<NovaSenha />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/" element={<LandingPage />} />
      <Route path="/sobre" element={<Sobre />} />
      <Route path="/trabalhe-conosco" element={<TrabalheConosco />} />
      <Route path="/seja-parceiro" element={<SejaParceiro />} />
      <Route path="*" element={<NotFound />} />
      <Route path="/cadastro-inicial" element={<CadastroInicial />} />
      <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
      <Route path="/aviso-privacidade" element={<AvisoPrivacidade />} />
      <Route path="/termo-de-uso" element={<TermoDeUso />} />
      <Route path="/produtos">
        <Route index element={<Produtos />} />
        <Route path="credito-consignado" element={<CreditoConsignado />} />
        <Route path="cartao-consignado" element={<CartaoConsignado />} />
        <Route path="FGTS" element={<Fgts />} />
        <Route path="credito-pessoal" element={<CreditoPessoal />} />
      </Route>
    </Routes>
  )
}

export default AppRoutes
